import { render, staticRenderFns } from "./TipoSolicitacaoEditar.vue?vue&type=template&id=d3f75608&"
import script from "./TipoSolicitacaoEditar.vue?vue&type=script&lang=js&"
export * from "./TipoSolicitacaoEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports